import { redirectTo } from "./redirectTo";

export const redirectFromSpanishSite = () => {
    if (!['production', 'imp'].includes(process.env.REACT_APP_ENV!)) {
        return;
    }
    if (window.location.hostname.includes('es.medicare')) {
        redirectTo(`https://medicare.gov${window.location.pathname}?Lang=es-mx`);
    }
    if (window.location.hostname.includes('es.imp.medicare')) {
        redirectTo(`https://imp.medicare.gov${window.location.pathname}?Lang=es-mx`)
    }
};